import { AppPathNames } from "@/constants/AppPathNames";
import { slices } from "@/constants/sliceNames";
import React from "react";
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";

export default function AuthGuard({ children }) {
  const { userToken: isAuth } = useSelector((state) => state[slices.auth]);
  const location = useLocation();

  if (!isAuth) {
    return <Navigate to={AppPathNames.signIn} replace state={{ from: location }} />;
  }

  return children;
}
